export default "__VITE_ASSET__b2498470__"